import * as React from 'react';

import {BulletedList} from 'shells/bulleted-list/bulleted-list';
import {GlossaryInfoModal} from 'shells/glossary-info-modal/glossary-info-modal';

import {OpenableModals, useOpenableModal} from '../../../openable-modals';

export function NewsletterInfoModal() {
    const {onClose} = useOpenableModal(OpenableModals.NEWSLETTER_INFO_MODAL);

    return (
        <GlossaryInfoModal
            onClose={onClose}
            artImage={
                <img src='/include/images/onboarding/open-envelope.svg' alt='Open email message' />
            }
            title='What are newsletters?'
            body={
                <p>
                    <BulletedList
                        bullets={[
                            <span key='bullet-1'>
                                Use a newsletter for ongoing campaigns, like a monthly or weekly
                                update
                            </span>,
                            <span key='bullet-2'>
                                Schedule ready-to-send editions for sending at a later date
                            </span>,
                            <span key='bullet-3'>
                                View edition engagement data and newsletter performance over time
                            </span>,
                        ]}
                    />
                </p>
            }
            learnEvenMoreHref='https://support.nutshell.com/en/articles/8428868-campaigns-how-to-create-email-newsletters'
        />
    );
}
